import { addInlineJS } from '@/helpers/html'
import { Atenea } from './types'

const atenea: Atenea = {
  init: () => {
    if (process.env.VUE_APP_COOKIEBOT_ATENEA_URL) {
      addInlineJS(process.env.VUE_APP_COOKIEBOT_ATENEA_URL, '', {
        'defer': true
      })
    }
  }
}

const ateneaPlugin = {
  install: () => {
    atenea.init()
  }
}

export default ateneaPlugin
